(function () {
    XonBoard.Map = {
        locationCell(latitude, longitude) {
            const valid = value => value !== null && value !== '' && isFinite(value);

            if (!valid(latitude) || !valid(longitude)) {
                return '<span class="text-grey5">&mdash;</span>';
            }

            return `<button type="button" class="location-cell" title="Show on map" data-lat="${latitude}" data-lng="${longitude}"
                        onclick="XonBoard.Map.showLocation(this)">
                        <i class="fa fa-location-dot" aria-hidden="true"></i>${(+latitude).toFixed(4)}, ${(+longitude).toFixed(4)}
                    </button>`;
        },
        showLocation(button) {
            const $modal = $('#location-map-modal');
            const center = [parseFloat(button.dataset.lng), parseFloat(button.dataset.lat)];

            $modal.find('.modal-title').text($(button).closest('tr').find('td').first().text().trim());
            $('#location-map-coords').text(`${button.dataset.lat}, ${button.dataset.lng}`);

            $modal.one('shown.bs.modal', () => {
                if (!this.locationMap) {
                    this.locationMap = new maplibregl.Map({
                        container: 'location-map',
                        style: `https://api.maptiler.com/maps/streets/style.json?key=${$('#location-map').data('map-key')}`,
                        center,
                        zoom: 14
                    });
                    this.locationMap.addControl(new maplibregl.NavigationControl({showCompass: false}));
                    this.locationMarker = new maplibregl.Marker({color: '#e74c3c'}).setLngLat(center).addTo(this.locationMap);
                } else {
                    this.locationMap.resize();
                    this.locationMap.jumpTo({center, zoom: 14});
                    this.locationMarker.setLngLat(center);
                }
            }).modal('show');
        },
        copyLocation(message) {
            navigator.clipboard.writeText($('#location-map-coords').text()).then(() => toastr.success(message));
        },
        singleMarkerMap: function (container, api_key, center, shouldWatchClick) {
            return {
                map: null,
                markers: [],
                longitude: null,
                latitude: null,
                shouldWatchClick: shouldWatchClick,
                changedManually() {
                    if(!this.longitude) {
                        return;
                    }

                    if(!this.latitude) {
                        return;
                    }

                    let lnglat = {lng: this.longitude, lat: this.latitude};

                    this.deleteMarkers();
                    this.addMarker(lnglat);
                },
                initMapWithMarker(longitude, latitude) {
                    this.initMap();
                    this.addMarker({lng: longitude, lat: latitude});
                    this.longitude = longitude;
                    this.latitude = latitude;
                },
                initMap() {
                    const hasCenter = center.longitude || center.latitude;

                    this.map = new window.maplibregl.Map({
                        container: container,
                        style: `https://api.maptiler.com/maps/streets/style.json?key=${api_key}`, // style URL
                    })
                        .setCenter(hasCenter ? {lng: center.longitude, lat: center.latitude} : {lng: 3.3792, lat: 6.5244})
                        .setZoom(hasCenter ? 12 : 9);

                    $(`#${container}`).closest('.modal').on('shown.bs.modal', () => this.map.resize());

                    this.map.on('load', () => {
                        $(`#${container}`).css('display', 'block');
                        this.map.resize();
                    });


                    if (this.shouldWatchClick) {
                        const self = this;
                        this.map.on("click", (mapMouseEvent) => {
                            self.deleteMarkers();
                            self.addMarker(mapMouseEvent.lngLat);
                        });
                    }

                    $(`#${container}`).css('height', '350px');
                },
                addMarker(lngLat) {
                    let marker = this.createMarker(lngLat);
                    this.markers.push(marker);

                    this.longitude = lngLat.lng;
                    this.latitude = lngLat.lat;
                },
                createMarker(position) {
                    return new window.maplibregl.Marker()
                        .setLngLat(position)
                        .addTo(this.map);
                },
                deleteMarkers() {
                    for (let i = 0; i < this.markers.length; i++) {
                        this.markers[i].remove();
                    }
                    this.markers = [];
                    this.longitude = null;
                    this.latitude = null;
                },
            };
        },
    };
}());
